export interface IFileDeleteResponse {
    succeeded: boolean;
    msg?: string;
}